module.exports = __webpack_public_path__ + "assets/img/pic.cde14f09.png";